<template>
  <div class="public-page">
      <div class="center">
        <img
          src="https://cdn.glitch.global/ef7d51e9-c240-42aa-87d5-de7d2f583cb9/concept-trust-icon.png?v=1651168013103"
          class="public-img"
        />
        <p class="mono">
          Winter 2020 - Present
        </p>
        <h1>
          Concept Trust
        </h1>
        <p class="description">
          A home for the safe-keeping of concepts. The trust acts as part-archive and part-museum for an orgainzation. It supports the roles of <a target="_blank" href="https://www.careering.life/roles/concept-composer">Concept Composers</a> and <a target="_blank" href="https://www.careering.life/roles/concept-librarian">Concept Librarians</a>.
        </p>
        <p class="public-footer">
          An experiment by <span class="mobile-show"><br></span><a target="_blank" href="https://tealprocess.net">Teal Process & Company</a>
        </p>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Public',
  components: {

  },
  computed: {
    willEnter() {
      if(this.$store.state.walletConnect.shouldAllow == true) {
        console.log('will entterrr')
        return 'will-enter';
      } else {
        return '';
      }
    },
  },
  mounted() {

  },
  methods: {
     connectWallet(){
       console.log('connecting wallet')
       this.$store.dispatch('connectWallet')
     },
  },
}

</script>

<style>

/* html, body {
  margin: 0;
  height: 100%;
  width: 100%;
  background: #f6e9da;
  color: #54504b;
  font-size: 10px;
} */

.public-page h1 {
  color: #000000;
  font-family: Untitled, sans-serif;
  font-weight: 600;
  line-height: 120%;
  margin: 0;
  font-size: 5.6em;
  margin-top: 8px;
  letter-spacing: -1px;
}

.public-page p {
  font-family: Untitled, sans-serif;
  font-weight: 400;
  font-size: 2em;
  line-height: 150%;
}

.public-page a {
  color: #54504b;
  transition: all 200ms ease-in-out;
}

.public-page a:hover {
  color: #000000;
  text-decoration: none;
}

.public-footer {
  font-family: 'Untitled Serif', serif;
  color: #978470;
}

.public-footer a {
  color: #978470;
}

.public-footer a:hover {
  color: #000000;
}

.public-page .mono {
  font-family: Lettera, monospace;
  font-size: 1.6em;
  line-height: 150%;
  margin: 0;
}



.public-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-size: 10px;
  /* background: #f6e9da; */
  color: #54504b;
}

.public-page .center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 620px;
  max-width: 90vw;
  margin-top: 18vh;
  text-align: center;
}

.public-page .description {
  font-size: 2em;
}


.public-img {
  width: 160px;
  height: auto;
  margin-bottom: 24px;
  background: none;
}

.public-page .mobile-show {
  display: none;
}

.public-page span {
  height: 0;
}



@media screen and (max-width: 600px) {
  /* html, body {
    font-size: 8px;
  } */

  .public-page {
    font-size: 8px;
  }

  .public-page .mobile-show {
    display: block;
  }

  .public-page h1 {
    font-size: 5em;
  }

  .public-page .center {
    margin-top: 13vh;
  }
}

</style>
